import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useQueryClient } from '@tanstack/react-query';
import { ClienteTable, CLIENTES_LISTA_QUERY_KEY } from '../components/clientes/ClienteTable.js';
import { NovoClienteModal } from '../modules/pedidos/components/NovoClienteModal';
import { useAuth } from '../hooks/useAuth';
import { CLIENTES_QUERY_KEY } from '../hooks/useClientes';

export function ClientesList() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const [novoClienteOpen, setNovoClienteOpen] = useState(false);

  return (
    <Box>
      <Box
        mb={3}
        sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}
      >
        <Box>
          <Typography variant="h4" fontWeight="bold">
            Clientes
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Clientes sincronizados do ERP
          </Typography>
        </Box>
        {/* AIDEV-NOTE: Gate de UI — o server tambem valida pode_cadastrar_clientes (403) */}
        {user?.pode_cadastrar_clientes && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setNovoClienteOpen(true)}
          >
            Novo cliente
          </Button>
        )}
      </Box>
      <ClienteTable />

      {/* AIDEV-NOTE: Reutiliza o modal do wizard de pedidos — mesma validacao e mesmo POST /clientes */}
      <NovoClienteModal
        open={novoClienteOpen}
        onClose={() => setNovoClienteOpen(false)}
        onClienteCriado={() => {
          // AIDEV-NOTE: invalida a tabela visivel (clientes-lista) e o cache do wizard (clientes)
          void queryClient.invalidateQueries({ queryKey: [CLIENTES_LISTA_QUERY_KEY] });
          void queryClient.invalidateQueries({ queryKey: [CLIENTES_QUERY_KEY] });
          setNovoClienteOpen(false);
        }}
      />
    </Box>
  );
}
